import { Vue, Prop, Component } from 'vue-property-decorator';
import { IProvider, ITemedRequest, ILocation } from '../../models';
import { AppService } from '../../services/AppService';
import * as DataService from '../../services/DataService';
import * as DistanceUtils from '../../utils/DistanceUtils';
import { EventBus, TEMED_WIDGET_EVENTS } from '../../services/EventBus';
import { PersonItem } from '../PersonItem';

import './RandomItemsWidget.scss';

@Component({
  template: require('./RandomItemsWidget.html'),
  components:{
    'person-item': PersonItem
  }
})
export class RandomItemsWidget extends Vue{

  @Prop({ default: '' })
  title: string;

  @Prop({ default: 'Spine' })
  medcat: string;

  @Prop({ default: 'doctors' })
  type: string;

  @Prop({ default: 'Find more doctors on temed.com' })
  linkText: string;

  @Prop({ default: 'https://www.temed.com/' })
  linkUrl: string;

  @Prop({ default: 2 })
  count: number;

  @Prop({ default: 2 })
  mobileCount: number;

  @Prop({ default: 768 })
  mobileBreakpoint: number;

  @Prop({ default: false })
  responsive: boolean;

  @Prop({ default: false })
  slider: boolean;

  @Prop({ default: 4})
  maxPageCount: number;

  mode = "desktop";

  appService: AppService;

  items: IProvider[] = [];

  page = 1;

  itemsCount = this.count;

  totalCount = 0;

  userLocation: ILocation = null;

  userState = DataService.DEFAULT_STATE;


  created(){
    this.appService = AppService.getInstance();
  }


  mounted(){
    this.userLocation = this.appService.get('userLocation');

    if(this.responsive){
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }

    EventBus.$on(TEMED_WIDGET_EVENTS.GEO_LOCATION_CHANGED, () => {
      this.appService.getUserLocation()
        .then(location => {
          const updatedLocation = this.userLocation === null ? true : false;
          this.userLocation = location;
          const updatedState = this.userLocation.state && this.userState !==  this.userLocation.state;
          if(updatedLocation || updatedState){
            this.userState = this.userLocation.state;
            this.initData();
          }
        }).catch(e => {
          console.log(e);
        });
    });
    this.initData();
  }

  initData(){

    const request: ITemedRequest ={
      query: '*',
      query_type: this.type,
      page: this.page,
      per_page: this.itemsCount,
      medcat_name: this.medcat,
      state: this.userState
    };
    DataService.searchProviders(request).then(response => {
      this.totalCount = response.data.total_count;
      const providers = response.data.providers;
      if(this.userLocation && this.userLocation.latitude != null && this.userLocation.longitude != null){
        providers.map(item => {
          item.distance = DistanceUtils.calcProviderDistance(this.userLocation, item);
        });
      }
      this.items = providers.length > this.itemsCount ? providers.slice(0, this.itemsCount) : providers;
    }).catch(e => {
      console.log(e);
    });
  }


  prev(){
    if(this.page === 1) { return; }
    this.page--;
    this.initData();
  }

  next(){
    if(this.page + 1 > this.maxPageCount) { return; }
    // if(this.page * this.count >= this.totalCount) { return; }
    this.page++;
    this.initData();
  }

  handleResize(){
    if(window.innerWidth < this.mobileBreakpoint){
      this.mode = 'mobile';
      if(this.mobileCount !== this.itemsCount){
        this.itemsCount = this.mobileCount;
        this.initData();
      }
    }else{
      this.mode = 'desktop';
      if(this.count !== this.itemsCount){
        this.itemsCount = this.count;
        this.initData();
      }
    }
  }
}
